//#region BOILERPLATE
export const BOILERPLATE_GUARDANDO = "BOILERPLATE_GUARDANDO";
export const BOILERPLATE_REINICIAR_ESTADO = "BOILERPLATE_REINICIAR_ESTADO";
//#endregion

//#region SIGNIN
export const SIGNIN_INICIAR_SESION = "SIGNIN_INICIAR_SESION";
export const SIGNIN_CERRAR_SESION = "SIGNIN_CERRAR_SESION";
export const SIGNIN_MODIFICAR_INPUTS = "SIGNIN_MODIFICAR_INPUTS";
export const SIGNIN_ASIGNAR_USUARIO_SESION = "SIGNIN_ASIGNAR_USUARIO_SESION";
export const SIGNIN_PROCESANDO = "SIGNIN_PROCESANDO";
//#endregion

//#region LAYOUT
export const LAYOUT_MOSTRAR_MENSAJE = "LAYOUT_MOSTRAR_MENSAJE";
export const LAYOUT_LIMPIAR_MENSAJES = "LAYOUT_LIMPIAR_MENSAJES";
export const LAYOUT_EXPANDIR_CONTRAER_MODULO =
  "LAYOUT_EXPANDIR_CONTRAER_MODULO";
export const LAYOUT_MOSTRAR_MODAL_ERROR = "LAYOUT_MOSTRAR_MODAL_ERROR";
export const LAYOUT_POBLAR_MODULOS = "LAYOUT_POBLAR_MODULOS";
export const LAYOUT_MOSTRAR_MODAL_CONFIRMACION_ACCION =
  "LAYOUT_MOSTRAR_MODAL_CONFIRMACION_ACCION";
export const LAYOUT_IS_BUSY = "LAYOUT_IS_BUSY";
export const LAYOUT_MOSTRAR_MODAL_SELECTOR = "LAYOUT_MOSTRAR_MODAL_SELECTOR";
export const LAYOUT_MODIFICAR_PAGINA_MODAL_SELECTOR =
  "LAYOUT_MODIFICAR_PAGINA_MODAL_SELECTOR";
export const LAYOUT_REINICIAR_LISTA_MODAL_SELECTOR =
  "LAYOUT_REINICIAR_LISTA_MODAL_SELECTOR";
export const LAYOUT_ACTUALIZAR_LISTADO_SELECTOR =
  "LAYOUT_ACTUALIZAR_LISTADO_SELECTOR";
export const LAYOUT_MOSTRAR_LOADING_SELECTOR =
  "LAYOUT_MOSTRAR_LOADING_SELECTOR";
//#endregion

//#region PARAMETROS
export const PARAMETROS_POBLAR_PARAMETROS = "PARAMETROS_POBLAR_PARAMETROS";
export const PARAMETROS_DISPLAY_MODAL_CREACION =
  "PARAMETROS_DISPLAY_MODAL_CREACION";
export const PARAMETROS_MODIFICAR_INPUTS = "PARAMETROS_MODIFICAR_INPUTS";
export const PARAMETROS_ADICIONAR_CONFIGURACION =
  "PARAMETROS_ADICIONAR_CONFIGURACION";
export const PARAMETROS_ELIMINAR_CONFIGURACIONES =
  "PARAMETROS_ELIMINAR_CONFIGURACIONES";
export const PARAMETROS_ELIMINAR_CONFIGURACION =
  "PARAMETROS_ELIMINAR_CONFIGURACION";
export const PARAMETROS_ACTUALIZAR_PARAMETRO =
  "PARAMETROS_ACTUALIZAR_PARAMETRO";
export const PARAMETROS_ACTUALIZAR_PARAMETROS =
  "PARAMETROS_ACTUALIZAR_PARAMETROS";
export const PARAMETROS_SELECCIONAR_PARAMETRO =
  "PARAMETROS_SELECCIONAR_PARAMETRO";
export const PARAMETROS_ADICIONAR_DETALLE = "PARAMETROS_ADICIONAR_DETALLE";
export const PARAMETROS_ELIMINAR_DETALLE = "PARAMETROS_ELIMINAR_DETALLE";
export const PARAMETROS_ELIMINAR_DETALLES = "PARAMETROS_ELIMINAR_DETALLES";
export const PARAMETROS_ACTUALIZAR_DETALLES_PARAMETRO =
  "PARAMETROS_ACTUALIZAR_DETALLES_PARAMETRO";
export const PARAMETROS_ELIMINAR_PARAMETROS = "PARAMETROS_ELIMINAR_PARAMETROS";
export const PARAMETROS_REINICIAR_ESTADO = "PARAMETROS_REINICIAR_ESTADO";
export const PARAMETROS_MODIFICAR_FILTRO = "PARAMETROS_MODIFICAR_FILTRO";
export const PARAMETROS_ORDENAR_COLUMNA = "PARAMETROS_ORDENAR_COLUMNA";
export const PARAMETROS_GUARDANDO = "PARAMETROS_GUARDANDO";
//#endregion

//#region NUEVASOLICITUD
export const NUEVASOLICITUD_INICIALIZAR_ESTADO =
  "NUEVASOLICITUD_INICIALIZAR_ESTADO";
export const NUEVASOLICITUD_GUARDANDO = "NUEVASOLICITUD_GUARDANDO";
export const NUEVASOLICITUD_LOADING = "NUEVASOLICITUD_LOADING";
export const NUEVASOLICITUD_REINICIAR_ESTADO =
  "NUEVASOLICITUD_REINICIAR_ESTADO";
export const NUEVASOLICITUD_REINICIAR_CAMPO = "NUEVASOLICITUD_REINICIAR_CAMPO";
export const NUEVASOLICITUD_ELIMINAR_DETALLE =
  "NUEVASOLICITUD_ELIMINAR_DETALLE";
export const NUEVASOLICITUD_POBLAR_PARAMETROS =
  "NUEVASOLICITUD_POBLAR_PARAMETROS";
export const NUEVASOLICITUD_ELIMINAR_RECURSO =
  "NUEVASOLICITUD_ELIMINAR_RECURSO";
export const NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_CENCOS =
  "NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_CENCOS";
export const NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES =
  "NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES";
export const NUEVASOLICITUD_ACTUALIZAR_DETALLES =
  "NUEVASOLICITUD_ACTUALIZAR_DETALLES";
export const NUEVASOLICITUD_ACTUALIZAR_DISTRIBUCIONES =
  "NUEVASOLICITUD_ACTUALIZAR_DISTRIBUCIONES";
export const NUEVASOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO =
  "NUEVASOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO";
export const NUEVASOLICITUD_RECALCULAR_TOTAL_SOLICITUD =
  "NUEVASOLICITUD_RECALCULAR_TOTAL_SOLICITUD";
//#endregion

//#region CENCOS
export const CENCOS_GUARDANDO = "CENCOS_GUARDANDO";
export const CENCOS_REINICIAR_ESTADO = "CENCOS_REINICIAR_ESTADO";
export const CENCOS_OBTENER_DATA = "CENCOS_OBTENER_DATA";
export const CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE =
  "CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE";
export const CENCOS_ACTUALIZAR_REGISTROS = "CENCOS_ACTUALIZAR_REGISTROS";
export const CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE_PRESUPUESTO =
  "CENCOS_MOSTRAR_OCULTAR_MODAL_CREATE_PRESUPUESTO";
export const CENCOS_ACTUALIZAR_PRESUPUESTOS = "CENCOS_ACTUALIZAR_PRESUPUESTOS";
export const CENCOS_ACTUALIZAR_TABLA_USUARIOS_MODAL_CREATE =
  "CENCOS_ACTUALIZAR_TABLA_USUARIOS_MODAL_CREATE";
export const CENCOS_MOSTRAR_OCULTAR_MODAL_CARGAR_PRESUPUESTO =
  "CENCOS_MOSTRAR_OCULTAR_MODAL_CARGAR_PRESUPUESTO";
//#endregion

//#region USUARIOS
export const USUARIOS_GUARDANDO = "USUARIOS_GUARDANDO";
export const USUARIOS_REINICIAR_ESTADO = "USUARIOS_REINICIAR_ESTADO";
export const USUARIOS_OBTENER_DATA = "USUARIOS_OBTENER_DATA";
export const USUARIOS_MOSTRAR_OCULTAR_MODAL_CREATE =
  "USUARIOS_MOSTRAR_OCULTAR_MODAL_CREATE";
export const USUARIOS_ACTUALIZAR_REGISTROS = "USUARIOS_ACTUALIZAR_REGISTROS";
//#endregion

//#region TIPOSERVICIO
export const TIPOSERVICIOS_GUARDANDO = "TIPOSERVICIOS_GUARDANDO";
export const TIPOSERVICIOS_REINICIAR_ESTADO = "TIPOSERVICIOS_REINICIAR_ESTADO";
export const TIPOSERVICIOS_OBTENER_DATA = "TIPOSERVICIOS_OBTENER_DATA";
export const TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE =
  "TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE";
export const TIPOSERVICIOS_ACTUALIZAR_REGISTROS =
  "TIPOSERVICIOS_ACTUALIZAR_REGISTROS";
export const TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE_TIPOPRODUCTO =
  "TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE_TIPOPRODUCTO";
export const TIPOSERVICIOS_ACTUALIZAR_TIPOSPRODUCTO =
  "TIPOSERVICIOS_ACTUALIZAR_TIPOSPRODUCTO";
export const TIPOSERVICIOS_ACTUALIZAR_TABLA_USUARIOS_MODAL_CREATE_TIPOPRODUCTO =
  "TIPOSERVICIOS_ACTUALIZAR_TABLA_USUARIOS_MODAL_CREATE_TIPOPRODUCTO";
//#endregion

//#region SOLICITUDES
export const SOLICITUDES_GUARDANDO = "SOLICITUDES_GUARDANDO";
export const SOLICITUDES_REINICIAR_ESTADO = "SOLICITUDES_REINICIAR_ESTADO";
export const SOLICITUDES_MOSTRAR_MODAL_MODICAR_ESTADO_SOLICITUDES =
  "SOLICITUDES_MOSTRAR_MODAL_MODICAR_ESTADO_SOLICITUDES";
//#endregion

//#region REPORTE1
export const REPORTE1_GUARDANDO = "REPORTE1_GUARDANDO";
export const REPORTE1_REINICIAR_ESTADO = "REPORTE1_REINICIAR_ESTADO";
export const REPORTE1_MOSTRAR_MODAL_MODICAR_ESTADO_SOLICITUDES =
  "REPORTE1_MOSTRAR_MODAL_MODICAR_ESTADO_SOLICITUDES";
//#endregion

//#region REPORTE2
export const REPORTE2_GUARDANDO = "REPORTE2_GUARDANDO";
export const REPORTE2_REINICIAR_ESTADO = "REPORTE2_REINICIAR_ESTADO";
//#endregion

//#region INTERFAZCONTABLE
export const INTERFAZCONTABLE_GUARDANDO = "INTERFAZCONTABLE_GUARDANDO";
export const INTERFAZCONTABLE_REINICIAR_ESTADO =
  "INTERFAZCONTABLE_REINICIAR_ESTADO";
export const INTERFAZCONTABLE_MOSTRAR_MODAL_GENERAR_INTERFAZ =
  "INTERFAZCONTABLE_MOSTRAR_MODAL_GENERAR_INTERFAZ";
//#endregion

//#region SOLICITUD
export const SOLICITUD_GUARDANDO = "SOLICITUD_GUARDANDO";
export const SOLICITUD_REINICIAR_ESTADO = "SOLICITUD_REINICIAR_ESTADO";
export const SOLICITUD_CARGAR_SOLICITUD = "SOLICITUD_CARGAR_SOLICITUD";
export const SOLICITUD_POBLAR_PARAMETROS = "SOLICITUD_POBLAR_PARAMETROS";
export const SOLICITUD_RECALCULAR_TOTAL_SOLICITUD =
  "SOLICITUD_RECALCULAR_TOTAL_SOLICITUD";
export const SOLICITUD_CANCELAR_SOLICITUD = "SOLICITUD_CANCELAR_SOLICITUD";
export const SOLICITUD_MOSTRAR_MODAL_CANCELAR_SOLICITUD =
  "SOLICITUD_MOSTRAR_MODAL_CANCELAR_SOLICITUD";
export const SOLICITUD_ACTUALIZAR_DETALLES = "SOLICITUD_ACTUALIZAR_DETALLES";
export const SOLICITUD_ACTUALIZAR_DISTRIBUCIONES =
  "SOLICITUD_ACTUALIZAR_DISTRIBUCIONES";
export const SOLICITUD_ELIMINAR_DETALLE = "SOLICITUD_ELIMINAR_DETALLE";
export const SOLICITUD_ELIMINAR_RECURSO = "SOLICITUD_ELIMINAR_RECURSO";
export const SOLICITUD_MOSTRAR_MODAL_ADICIONAR_CENCOS =
  "SOLICITUD_MOSTRAR_MODAL_ADICIONAR_CENCOS";
export const SOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES =
  "SOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES";
export const SOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO =
  "SOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO";
export const SOLICITUD_MARCAR_ACTUALIZADA = "SOLICITUD_MARCAR_ACTUALIZADA";
export const SOLICITUD_CREAR_DISTRIBUCIONES_DETALLES_UNCHANGED =
  "SOLICITUD_CREAR_DISTRIBUCIONES_DETALLES_UNCHANGED";
export const SOLICITUDES_AJUSTAR_LISTA_CAFETERIAS =
  "SOLICITUDES_AJUSTAR_LISTA_CAFETERIAS";
//#endregion

//#region PLANTILLAS
export const PLANTILLAS_GUARDANDO = "PLANTILLAS_GUARDANDO";
export const PLANTILLAS_REINICIAR_ESTADO = "PLANTILLAS_REINICIAR_ESTADO";
export const PLANTILLAS_OBTENER_DATA = "PLANTILLAS_OBTENER_DATA";
export const PLANTILLAS_MOSTRAR_OCULTAR_MODAL_CREATE =
  "PLANTILLAS_MOSTRAR_OCULTAR_MODAL_CREATE";
export const PLANTILLAS_ACTUALIZAR_REGISTROS =
  "PLANTILLAS_ACTUALIZAR_REGISTROS";
//#endregion
